import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from '../../hooks/useConfiguration';
import useSessionStorage from '../../hooks/useSessionStorage';
import { ChatWindow } from "../common/chatWindow";
import Footer from "../common/Footer";
import Header from "../common/Header";
import Loader from "../common/Loader";
import Sidebar from "../common/Sidebar";
import { clearData, getMessagesData, getPersonalMsg, sendPersonal, updateMsgFlag } from './action';
import './index.css';
import { jobmessagesSelector } from "./selector";


const JobMessages = () => {
    const { data, chat, msgSendFlag } = useSelector(jobmessagesSelector);
    const config = useConfiguration();
    const location = useLocation();
    const storage = useSessionStorage();
    const login = storage.getItem("login");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [openMessaging, setOpenMessaging] = useState(false);
    const [chatData, setChatData] = useState([]);
    const [msgParams, setmsgParams] = useState({
        "webPageId": 0,
        "shiftUniqueId": '',
        "candidateUniqueId": '',
        "employerUniqueId": ''
    });
    const { jobUniqueId } = location.state || ''
    const { candidateUniqueId } = location.state || ''

    useEffect(() => {
        if (config.baseUrl) {
            if (!login) {
                navigate("/");
            } else if (jobUniqueId) {
                const newparams = {
                    "webPageId": 0,
                    "shiftUniqueId": jobUniqueId,
                    "candidateUniqueId": candidateUniqueId,
                    "employerUniqueId": login.employerUniqueId,
                    "employerUserId": login.employerUserId
                }
                dispatch(getMessagesData({
                    url: `${config.baseUrl}/Messages/get-candidates-by-job-messages`, params: newparams
                }));
            }
        }
    }, [config]);

    const openChantWindow = (shiftUniqueId, candidateUniqueId) => {
        if (shiftUniqueId && candidateUniqueId) {
            setmsgParams({
                "webPageId": 0,
                "shiftUniqueId": shiftUniqueId,
                "candidateUniqueId": candidateUniqueId,
                "employerUniqueId": login.employerUniqueId,
                "employerUserId": login.employerUserId
            });
            const newparams = {
                "webPageId": 0,
                "shiftUniqueId": shiftUniqueId,
                "candidateUniqueId": candidateUniqueId,
                "employerUniqueId": login.employerUniqueId,
                "employerUserId": login.employerUserId
            }
            dispatch(getPersonalMsg({
                url: `${config.baseUrl}/Messages/GetEmployerMessages`, params: newparams
            }));
            setOpenMessaging(!openMessaging);
        }
    }

    const sendMsg = (text) => {
        // console.log(text);
        // console.log(msgParams);
        const newparams = {
            ...msgParams,
            "fromCandidate": false,
            "messageText": text
        }
        dispatch(sendPersonal({
            url: `${config.baseUrl}/Messages/SendMessageToCandidate`, params: newparams
        }));
    }

    useEffect(() => {
        // console.log('call msg');
        if (msgSendFlag && config.baseUrl) {
            dispatch(getPersonalMsg({
                url: `${config.baseUrl}/Messages/GetEmployerMessages`, params: msgParams
            })).then(() => {
                dispatch(updateMsgFlag(false))
            });
        }
    }, [msgSendFlag])

    useEffect(() => {
        // console.log('crete group');
        const newData = JSON.parse(JSON.stringify(chat));
        buildGroupMsg(newData)
    }, [chat]);

    const buildGroupMsg = (data) => {
        const groups = data.reduce((groups, messages) => {
            const date = messages.messageDateTime.split('T')[0];
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(messages);
            return groups;
        }, {});

        const groupMsg = Object.keys(groups).map(date => {
            return {
                date,
                messages: groups[date]
            };
        })
        // console.log(groupMsg)
        setChatData(groupMsg);
    }

    useEffect(() => {
        return () => {
            dispatch(clearData());
        }
    }, [])


    return (
        <div className="page main-margin">
            <Loader />
            <Header />
            <Sidebar />
            <div className="page-main">
                <div className="main-content app-content mt-0 main-background">
                    <div className="side-app">
                        <div className="main-container container-fluid">
                            <div className="page-header">
                                <h1 className="page-title">Job Conversations</h1>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card">
                                        <div className="card-header d-flex justify-content-between">
                                            <h3 className="card-title">Job Info</h3>
                                            <span className="float-right"><button className="btn btn-danger" onClick={() => navigate(-1)}>Back</button></span>
                                        </div>
                                        <div className="card-body">
                                            <div className='row mt-3 ms-4'>
                                                <span className='fw-bolder'><h4>Job info:</h4></span>
                                                <div className='row'>
                                                    <div className="col-md-6">
                                                        <label className="form-label">Job Code:</label>
                                                        <label>{data?.jobInfo?.jobCode}</label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label">Job Date:</label>
                                                        <label>{data?.jobInfo?.jobDateToDisplay}</label>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-6">
                                                        <label className="form-label">Job Title:</label>
                                                        <label>{data?.jobInfo?.jobTitle}</label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label">Job Description:</label>
                                                        <label dangerouslySetInnerHTML={{ __html: data?.jobInfo?.jobDescription }} />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-6">
                                                        <label className="form-label">Checked In Date:</label>
                                                        <label>{data?.jobInfo?.checkedInDateToDisplay}</label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label">Checked Out Date:</label>
                                                        <label>{data?.jobInfo?.checkedOutDateToDisplay}</label>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-6">
                                                        <label className="form-label">shift Start Time:</label>
                                                        <label>{data?.jobInfo?.shiftStartTime}</label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label">shift End Time:</label>
                                                        <label>{data?.jobInfo?.shiftEndTime}</label>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-6">
                                                        <label className="form-label">shift Hours:</label>
                                                        <label>{data?.jobInfo?.shiftHours}</label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label">Paid Date:</label>
                                                        <label>{data?.jobInfo?.paidDateToDisplay}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="col-lg-4 col-md-4">
                                                <h4 className="card-title">
                                                    Messages
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            {
                                                data && data?.candidatesList?.length > 0 ?
                                                    data?.candidatesList.map(item => (
                                                        <>
                                                            <div className='d-flex justify-content-between'>
                                                                <span>{item?.candidateName}</span>
                                                                <span onClick={() => { openChantWindow(data?.jobInfo?.shiftUniqueId, item?.candidateUniqueId) }}><i className="fa fa-reply fa-lg text-success"></i> Send a message</span>
                                                                {item?.isMessageRead ? <span><i className="bi bi-envelope-open fa-lg text-primary"></i> Read</span> : <span><i class="bi bi-envelope fa-lg text-primary"></i> Mark as Read</span>}
                                                            </div>
                                                            <hr style={{
                                                                color: 'black',
                                                                backgroundColor: 'black',
                                                                height: 1
                                                            }} />
                                                        </>
                                                    ))
                                                    : ''
                                            }
                                            {/* {
                                                <div className="message-overlay">
                                                    {openMessaging && <ChatWindow closeChatWindow={() => {
                                                        setOpenMessaging(!openMessaging)
                                                    }}
                                                        chatData={chatData}
                                                        sendMsg={sendMsg}
                                                    />}
                                                </div>
                                            } */}
                                            {openMessaging && chatData.length > 0 && <div className="message-position">
                                                <ChatWindow closeChatWindow={() => {
                                                    setOpenMessaging(!openMessaging)
                                                }}
                                                    chatData={chatData}
                                                    sendMsg={sendMsg}
                                                />
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-right mb-3"><button className="btn btn-danger" onClick={() => navigate(-1)}>Back</button></div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default JobMessages